import { render, staticRenderFns } from "./nuevaSolicitud.vue?vue&type=template&id=1bb85bcc&scoped=true"
import script from "./nuevaSolicitud.vue?vue&type=script&lang=js"
export * from "./nuevaSolicitud.vue?vue&type=script&lang=js"
import style0 from "./nuevaSolicitud.vue?vue&type=style&index=0&id=1bb85bcc&prod&scoped=true&lang=css"
import style1 from "./nuevaSolicitud.vue?vue&type=style&index=1&id=1bb85bcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb85bcc",
  null
  
)

export default component.exports